export const FETCH_CORRECTIBLE_BEGIN = "FETCH_CORRECTIBLE_BEGIN";
export const FETCH_CORRECTIBLE_SUCCESS = "FETCH_CORRECTIBLE_SUCCESS";
export const FETCH_CORRECTIBLE_FAILURE = "FETCH_CORRECTIBLE_FAILURE";

export const SUBMIT_CORRECTIBLE_BEGIN = "SUBMIT_CORRECTIBLE_BEGIN";
export const SUBMIT_CORRECTIBLE_SUCCESS = "SUBMIT_CORRECTIBLE_SUCCESS";
export const SUBMIT_CORRECTIBLE_FAILURE = "SUBMIT_CORRECTIBLE_FAILURE";

